import { Outlet } from "react-router-dom";

/**
 * Wrapper for legal routes
 * These routes are always accessible (privacy policy, terms of service, etc.)
 */
export function LegalRouteWrapper() {
  return <Outlet />;
}
